<template>
	<section class="section-app">
		<section-head
			title="Your Order"
			description="Confirm your order to checkout"
		/>

		<div class="section__container">
			<div class="section__bg"
				:style="`background-image: url(${assetImage}/images/watermark.png)`"
			>

			</div><!-- /.section__bg -->
			<div class="section__aside">
				<h2>{{title}}</h2>

				<h3>{{date}}</h3>

				<div class="section__info" v-html="orderLeftText"></div><!-- /.section__info -->

			<p class="agree__policy" :style="agree_style">
			<input type="radio" name="agree_policy" id="agree_policy" value="agree" v-model="agreed" >  {{acknowledgement}}
			</p>					
			</div><!-- /.section__aside -->

			<div class="section__content">
				<div class="list-specifications">
					<ul>
						<li>
							<p>
								<strong>Deck</strong> <em>{{selectedDeck.title}}</em>
							</p>
						</li>
						<li>
							<p>
								<strong>Cabin Type</strong> <em>{{cabinTypes}}</em>
							</p>
						</li>
						<li>
							<p>
								<strong>Cabin #</strong> <em>{{selectedCabin.number}}</em>
							</p>
						</li>
						<li>
							<h5>
								<em>Subtotal</em> <strong>${{formatedNumber(formatNumber(this.selectedCabin.price))}}</strong>
							</h5>
							<h5 v-if="extraFees > 0">
								<em>Extra Traveler Fees:</em> <strong>${{formatedNumber(formatNumber(extraFees))}}</strong>
							</h5>
							<h5>
								<em>Taxes, Fees &amp; Port Expenses</em> <strong>${{formatedNumber(formatNumber(selectedCabin.port_taxes * product.passengers))}}</strong>
							</h5>
							<h5>
								<em>Prepaid Gratuities</em> <strong>${{formatedNumber(formatNumber(selectedCabin.gratuity * product.passengers ))}}</strong>
							</h5>
							<h5 v-if="specialFees > 0">
								<em>{{specialFeeTitle}}:</em> <strong>${{formatedNumber(formatNumber(specialFees))}}</strong>
							</h5>

							<h5>
								<em>TOTAL</em> <strong>${{formatedNumber(formatNumber(totalPrice))}}</strong>
							</h5>

							<h4>
								<em>Deposit Due:</em>
								<strong>${{formatedNumber(formatNumber(depositDue))}}</strong>
							</h4>
						</li>
					</ul>
				</div>

				<div class="section__foot">
					<button
						class="btn btn-gray"
						@click="handlePrevClick"
					>
						Back
					</button>

					<a
						:href="checkoutUrl"
						class="btn btn-blue btn-continue3"
		   				@click="handleContinueClick"
					>
						Continue
					</a>
				</div><!-- /.section__foot -->

				<div class="section__info" v-html="orderText"></div><!-- /.section__info -->

			</div><!-- /.section__content -->

		</div><!-- /.section__container -->

	</section><!-- /.section -->
</template>

<script>

	/**
	* External Dependencies
	*/
	import { mapGetters, mapActions } from 'vuex';
	import { reduce } from 'lodash';

	/**
	* Internal Dependencies
	*/
	import SectionHead from '../components/SectionHead.vue';
	import numberFormat from '../mixins/number-format';

	export default {
		/**
		* Component Name.
		*
		* @type {String}
		*/
		name: 'cruise-order',

		mixins: [numberFormat],

		data() {
			return {
				checkoutUrl: crb_booking_app.checkout_url,
				assetImage: crb_app.theme_url,
				title: crb_app.app_data.heading,
				date: crb_app.app_data.date,
				orderLeftText: crb_booking_app.order_left_text,
				orderText: crb_booking_app.order_text,
				depositStatus: crb_app.app_data.deposit_status,
				acknowledgement: crb_app.app_data.acknowledgement,
			       agreed: '', agree_style:'',
			}
		},

		components: {
			SectionHead
		},

		computed:{
			...mapGetters({
				'product':'getProduct',
				'decks':'getDecks',
			}),

			selectedDeck(){
				const selectedDeck = this.decks.filter(deck => deck.id === this.product.deck)

				return selectedDeck[0];
			},

			selectedCabin() {
				return this.selectedDeck.cabins.filter(cabin => cabin.id === this.product.cabin)[0];
			},

			cabinTypes() {
				return _.reduce( this.selectedCabin.type, (typeString, type) => {
					typeString = ! typeString ? type : `${typeString} | ${type}`;

					return typeString;
				}, '' );
			},

			extraFees() {
				if ( ( this.product.passengers - 2 ) > 0 ) {
					this.selectedCabin.extra_traveler_fees = this.selectedCabin.extra_traveler_fees;
				} else {
					this.selectedCabin.extra_traveler_fees = 0;
				}
				return parseFloat(this.selectedCabin.extra_traveler_fees);
			},

			specialFees() {
			  if(crb_app.app_data.special_fee_restrict != 'yes' || this.product.passengers  == 1 )
			    return parseFloat(crb_app.app_data.special_fee_amount);
			  else {
			    crb_app.app_data.special_fee_amount = 0;
			    return 0;
			  }
			},

			specialFeeTitle() {
					return crb_app.app_data.special_fee_name;
			},

			totalPrice() {
			  var sfee = 0;
			  if(crb_app.app_data.special_fee_restrict != 'yes' || this.product.passengers  == 1 )
			    sfee = parseFloat(crb_app.app_data.special_fee_amount);
				return parseFloat( (parseFloat(this.selectedCabin.port_taxes) + parseFloat(this.selectedCabin.gratuity) ) * this.product.passengers + parseFloat(this.selectedCabin.price) + parseFloat(this.selectedCabin.extra_traveler_fees) + sfee).toFixed(2)
			},

			depositDue() {
				if ( crb_app.app_data.deposit_status ) {
					return parseFloat( ( parseFloat(this.selectedCabin.port_taxes) + parseFloat(this.selectedCabin.gratuity) ) * this.product.passengers + ( parseFloat(this.selectedCabin.price) + parseFloat(this.selectedCabin.extra_traveler_fees) ) * ( parseFloat(crb_booking_app.deposit_percentage) * 0.01 ) ).toFixed(2)
				} else {
					return parseFloat( ( parseFloat(this.selectedCabin.price) + parseFloat(this.selectedCabin.extra_traveler_fees) ) * ( parseFloat(crb_booking_app.deposit_percentage) * 0.01 ) ).toFixed(2)
				}
			},
		},

		methods: {
			handlePrevClick() {
				this.$router.push({name:'cruise.cabin'})
			},

			formatedNumber(number){
				return Number(number).toLocaleString('en-US')
			},
			handleContinueClick(event) {
			  if(this.agreed != "agree") {
    			    event.preventDefault();
			    this.agree_style="color:red !important";
 			    return false;
			  }		
			}
		},

		mounted() {
			if ( crb_booking_app.load_session_data ) {
				this.selectedCabin.total = this.selectedCabin.total ? this.selectedCabin.total : crb_booking_app.session_data.room.total_taxes / this.product.passengers;
				this.selectedCabin.extra_traveler_fees = this.selectedCabin.extra_traveler_fees ? this.selectedCabin.extra_traveler_fees : crb_booking_app.session_data.room.extra_traveler_fees;
				this.selectedCabin.gratuity = this.selectedCabin.gratuity ? this.selectedCabin.gratuity : crb_booking_app.session_data.room.gratuity_tax;
				this.selectedCabin.port_taxes = this.selectedCabin.port_taxes ? this.selectedCabin.port_taxes : parseFloat(crb_booking_app.session_data.room.port_tax) / this.product.passengers;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/CruiseOrder.vue